// Kinhall's art layout: where the lanterns and the furniture stand (tiles, foot points). Shared by client/kinhall.ts,
// which draws them among the trainers (the lanterns flicker, the braziers burn), and art/rig3d/build-kinhall.ts, which
// paints their pools of light on the floor. Art owns this file.
export const HALL_LANTERNS: [number, number][] = [[15.6, 7.3], [32.4, 7.3], [20.9, 19.5], [27.1, 19.5]];

/** Braziers where the main path crosses into the realms' floors, and either side of the runner inside the Road gate. */
export const HALL_BRAZIERS: [number, number][] = [[14.6, 13.7], [33.4, 13.7], [19.6, 24.4], [28.4, 24.4]];

/** The furniture: benches round the Well's approach and in each realm, bonsai boxes by the torii, olives in the east,
 *  a runestone and a snowy bush in the west, an amphora by the Merchant. */
export const HALL_DECOR: [string, number, number, boolean?][] = [
  ...HALL_BRAZIERS.map(([x, y]): [string, number, number] => ['prop-hall-brazier', x, y]),
  ['prop-hall-bench-midgard', 18.3, 10.8], ['prop-hall-bench-hellas', 29.7, 10.8],
  ['prop-hall-bench-midgard', 4.8, 19.4], ['prop-hall-bench-hellas', 43.2, 19.4],
  ['prop-hall-planter-yomi', 8.2, 7.5], ['prop-hall-planter-yomi', 13.8, 7.5, true],
  ['prop-hall-planter', 34.2, 8.6], ['prop-hall-planter', 44.0, 10.4, true], ['prop-hall-planter', 44.0, 24.6],
  ['prop-midgard-runestone', 4.3, 10.8], ['prop-midgard-snowbush', 4.4, 24.6], ['prop-hellas-amphora', 42.6, 13.6],
];
